import type { FeatureManagementConfig } from "./types";

export function buildSplitConfig(config: FeatureManagementConfig): SplitIO.IBrowserSettings {
  const useLocalhost = config.useLocalhost;
  const hasSdkKey = config.sdkKey.trim().length > 0;
  const useControlOnlyFallback = !useLocalhost && !hasSdkKey;
  const base: SplitIO.IBrowserSettings = {
    core: {
      authorizationKey: useLocalhost || useControlOnlyFallback ? "localhost" : config.sdkKey,
      key: config.userKey,
    },
    streamingEnabled: useLocalhost || useControlOnlyFallback ? false : config.streamingEnabled ?? true,
    startup: {
      readyTimeout: useLocalhost || useControlOnlyFallback ? 1 : 5,
      retriesOnFailureBeforeReady: 1,
      eventsFirstPushWindow: 0,
    },
    urls: config.urls,
  };

  if (useLocalhost) {
    return { ...base, features: config.localFeatures ?? {} };
  }

  if (useControlOnlyFallback) {
    return { ...base, features: {} };
  }

  return base;
}
